type NumberFormatConfig =
  | boolean
  | {
      enabled?: boolean
      locale?: string
      options?: Intl.NumberFormatOptions
    }

export type SimplePropertySchemaWithNumberFormat = {
  'ui-params'?: {
    numberFormat?: NumberFormatConfig
  }
}

export const getNumberFormatter = (property: SimplePropertySchemaWithNumberFormat) => {
  const numberFormat = property['ui-params']?.numberFormat

  if (!numberFormat) {
    return undefined
  }

  if (typeof numberFormat === 'object' && numberFormat.enabled === false) {
    return undefined
  }

  const formatter =
    typeof numberFormat === 'object'
      ? new Intl.NumberFormat(numberFormat.locale, numberFormat.options)
      : new Intl.NumberFormat()

  return (incomingValue: unknown) => {
    if (incomingValue == null || incomingValue === '') {
      return ''
    }

    const parsedValue = Number(incomingValue)

    if (Number.isNaN(parsedValue)) {
      return String(incomingValue)
    }

    return formatter.format(parsedValue)
  }
}
